import {Component, OnInit, DoCheck, OnDestroy} from '@angular/core';
import {OfferStats} from '../../../models/offerStats';
import {SearchRecord} from '../../../models/searchRecord';
import {DataStorageService} from '../../data-storage.service';
import {Router} from '@angular/router';
import {ApiService} from '../../api.service';
import {Offer} from '../../../models/offer';
import {ApiFollowUpService} from '../../apiServices/followUp/api-follow-up.service';
import {ApiOfferService} from '../../apiServices/offer/api-offer.service';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {PricingService} from '../../pricing.service';
import {SecurityService} from '../../security.service';
import {Associate} from '../../../models/associate';
import {ApiCustomerService} from '../../apiServices/customer/api-customer.service';
import {ApiBagService} from '../../apiServices/bag/api-bag.service';
import {AvailableComponents} from '../../side-bar/enumAvailableComponents';


class Months {
  dateFrom: string;
  dateTo: string;
  value: number;
  text: string;

  constructor(dateFrom, dateTo, value, month, year) {
    this.dateFrom = dateFrom;
    this.dateTo = dateTo;
    this.value = value;
    this.text = month + ' - ' + year;
  }
}

@Component({
  selector: 'app-my-offers',
  templateUrl: './my-offers.component.html',
  styleUrls: ['./my-offers.component.scss']
})
export class MyOffersComponent implements OnInit, DoCheck, OnDestroy {

  replaced: string;
  offerStats: OfferStats;
  searchRecords: SearchRecord[];
  statusList: string[];
  stageList: string[];
  nextStepList: string[];
  chosenStatus: string;
  people: Associate[];
  inputData: {
    people: string,
    period: number,
    offerStatus: string,
    offerNumber: string,
    companyName: string,
    contactPerson: string,
    postalCode: string,
    city: string,
    phoneNumber: string,
    mobileNumber: string,
    salesStage: string,
    nextStep: string,
    dateFrom: NgbDateStruct,
    dateTill: NgbDateStruct;
  };
// fields used by DoCheck
  private previousPeople: string;
  private previousPeriod: number;

  constructor(
    private dataStorageService: DataStorageService,
    private pricing: PricingService,
    private router: Router,
    private api: ApiService,
    private bagApi: ApiBagService,
    private cuApi: ApiCustomerService,
    private fuApi: ApiFollowUpService,
    private oApi: ApiOfferService,
    private security: SecurityService) {
    this.offerStats = new OfferStats();
    this.previousPeople = '';
    this.replaced = '';
    this.statusList = [];
    this.stageList = [];
    this.nextStepList = [];
    this.chosenStatus = 'ALL';
    this.searchRecords = [];
    this.inputData = {
      'people': '',
      'period': 13,
      'offerStatus': '',
      'offerNumber': '',
      'companyName': '',
      'contactPerson': '',
      'postalCode': '',
      'city': '',
      'phoneNumber': '',
      'mobileNumber': '',
      'salesStage': '',
      'nextStep': '',
      'dateFrom': {year: 2010, month: 6, day: 27},
      'dateTill': {year: 2020, month: 6, day: 27}
    };
  }

  stringifyDateStruct(ds: NgbDateStruct): string {
    const d = ds.day >= 10 ? ds.day : ('0' + ds.day);
    const m = ds.month >= 10 ? ds.month : ('0' + ds.month);
    return (ds.year + '-' + m + '-' + d) as string;
  }

  ngOnInit() {
    const element = document.getElementById('myOffers');
    element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents.MyOffers;
    if (this.dataStorageService.ispPricingIPWORLDCOM === undefined) {
      this.pricing.initializePricing();
    }

    if (this.security.authorization.user.authorities.indexOf('ROLE_LEADER') > -1) {
      this.security.getPartnersAssociates().then(response => this.people = response);
    } else {
      this.people = [];
    }

    this.oApi.getPossibleOfferStatus().then(data => this.statusList = data);
    this.fuApi.getSalesStage().then(data => this.stageList = data);
    this.fuApi.getNextStep().then(data => this.nextStepList = data);
    this.oApi.getOfferOverview().then(data => this.offerStats = data);
    this.oApi.getOffers(null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      0,
      1000).then(data => this.searchRecords = data);
  }

  ngOnDestroy() {
    const element = document.getElementById('myOffers');
    element.classList.remove('active');
  }


  ngDoCheck() {
    if (this.previousPeriod !== this.inputData.period || this.previousPeople !== this.inputData.people) {
      this.previousPeriod = this.inputData.period;
      this.previousPeople = this.inputData.people;
      switch (parseInt(this.inputData.period.toString(), 10)) {
        case 0: {
          const date = new Date();
          const from = date.getFullYear() - 1 + '-01-01';
          const to = date.getFullYear() - 1 + '-12-31';
          this.oApi.getOfferOverview(this.inputData.people, {
            dateFrom: from,
            dateTo: to
          }).then(data => this.offerStats = data);
          break;
        }
        case 13: {
          const date = new Date();
          const from = date.getFullYear() + '-01-01';
          const dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
          const mm = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
          const to = date.getFullYear() + '-' + mm + '-' + dd;
          this.oApi.getOfferOverview(this.inputData.people, {
            dateFrom: from,
            dateTo: to
          }).then(data => this.offerStats = data);
          break;
        }
        default: {
          const toBeFiltered = this.generateMonthsArray();
          const value = Number(this.inputData.period);
          const filtered = toBeFiltered.filter(e => e.value === value);
          this.oApi.getOfferOverview(this.inputData.people, {
            dateFrom: filtered[0].dateFrom,
            dateTo: filtered[0].dateTo
          }).then(data => this.offerStats = data);
          break;
        }
      }
    }
  }

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  generateMonthsArray(): Months[] {
    const currentDate = new Date();
    const effect = [];
    let year = currentDate.getFullYear() - 1;
    let month = currentDate.getMonth() + 2;
    let value = 1;
    while (effect.length < 12) {
      let dateFrom;
      let dateTo;
      if (month < 10) {
        dateFrom = '' + year + '-' + 0 + month + '-' + '01';
        dateTo = '' + year + '-' + 0 + month + '-' + this.daysInMonth(month, year);
      } else {
        dateFrom = '' + year + '-' + month + '-' + '01';
        dateTo = '' + year + '-' + month + '-' + this.daysInMonth(month, year);
      }

      effect.push(new Months(
        dateFrom,
        dateTo,
        value,
        month,
        year));
      month++;
      value++;
      if (month === 13) {
        year++;
        month = 1;
      }
    }
    return effect;
  }



  replaceABC(event: any): string {
    this.replaced = event.target.value.replace(/[a-z]|[A-Z]/g, '');
    return this.replaced;
  }

  loadOffer(offerID: number, offerNumber: string) {
    this.dataStorageService.currentState.offerNumber = offerNumber;
    this.dataStorageService.currentState.offerID = offerID;
    this.fuApi.getFollowUp(offerID);
    this.cuApi.getCustomer(offerID);
    this.bagApi.getBagDevice(offerID)
      .then(data => this.dataStorageService.currentState.deviceBag = data);
    this.oApi.getOfferOptions(this.dataStorageService.currentState.offerID).then(() => {
      this.dataStorageService.sideBarAccordion.edit = true;
      this.router.navigate(['/customerProfile']);
    });
    this.dataStorageService.sideBarAccordion.edit = false;
  }

  addNewOffer() {
    if (this.dataStorageService.currentState.offerID !== 0) {
      this.dataStorageService.currentState = new Offer();
    }
    this.oApi.postOffer().then(() => {
    this.fuApi.getFollowUp(this.dataStorageService.currentState.offerID);
      this.dataStorageService.sideBarAccordion.edit = true;
      this.router.navigate(['/customerProfile']);
    });
    this.dataStorageService.sideBarAccordion.edit = false;
  }

  searchClick() {
    this.inputData.offerStatus = this.inputData.offerStatus === 'ALL' ? '' : this.inputData.offerStatus;
    this.oApi.getOffers(this.inputData.offerStatus,
      this.inputData.offerNumber,
      this.inputData.companyName,
      this.inputData.contactPerson,
      this.inputData.salesStage,
      this.inputData.nextStep,
      this.inputData.postalCode,
      this.inputData.city,
      this.inputData.phoneNumber,
      this.inputData.mobileNumber,
      this.stringifyDateStruct(this.inputData.dateFrom),
      this.stringifyDateStruct(this.inputData.dateTill),
      this.inputData.people,
      0,
      1000).then(data => this.searchRecords = data);
    this.inputData.offerStatus = this.inputData.offerStatus === '' ? 'ALL' : this.inputData.offerStatus;
  }

  cancelClick() {
    this.inputData = {
      'people': '',
      'period': 13,
      'offerStatus': '',
      'offerNumber': '',
      'companyName': '',
      'contactPerson': '',
      'postalCode': '',
      'city': '',
      'phoneNumber': '',
      'mobileNumber': '',
      'salesStage': '',
      'nextStep': '',
      'dateFrom': {year: 2010, month: 6, day: 27},
      'dateTill': {year: 2020, month: 6, day: 27}
    };
    this.searchClick();
  }

  deleteOfferClick(offerID: number, index: number) {
    if(confirm("Are you sure to delete")) {
      if (this.searchRecords[index].status === 'OPEN') {
        this.oApi.deleteOffer(offerID).then(() => {
          this.searchRecords.splice(index, 1);
        });
      } else {
        alert('You can not delete WON/LOST offer !');
      }
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/content/my-offers/my-offers.component.ts